'use strict';

class Tooltip {
  constructor(elem) {
    this.elem = elem;
    this.otherTooltip = document.querySelectorAll('.tooltip');
    this.tooltipButton = this.elem.querySelector(`[data-trigger-tooltip]:not([data-tooltip-alert])`);
    this.target = this.elem.querySelector(`[data-content-tooltip]`);
    this.positionClasses = {right: 'tooltip-right', center: 'tooltip-center'};
    
    this.events();
  }

  events() {
    if( this.tooltipButton ) {
      this.tooltipButton.addEventListener('focusin', e => { this.open() })
      this.tooltipButton.addEventListener('mouseover', e => { this.open() })
      this.tooltipButton.addEventListener('focusout', e => { this.close() })
      this.tooltipButton.addEventListener('mouseout', e => { this.close() })
    }
  }

  calculatePosition() {
    const windowWidth = document.documentElement.clientWidth;
    const viewportOffset = this.elem.getBoundingClientRect();
    const tooltipContentWidth = parseInt(window.getComputedStyle(this.target).width.replace('px', ''))
    ;
    const tooltipLeft = viewportOffset.left;
    const tooltipRight = windowWidth - viewportOffset.left;

    if (tooltipLeft > (windowWidth/2) && (tooltipRight + tooltipContentWidth <= windowWidth)) {
      this.target.classList.add(this.positionClasses.right);
    } else if (tooltipLeft >= (windowWidth/2) && (tooltipLeft + tooltipContentWidth > windowWidth)) {
      this.target.classList.add(this.positionClasses.center);
    }
  }

  open() {
    for (let otherTooltip of this.otherTooltip) {
      otherTooltip !== this.elem && otherTooltip.tooltip.close();
    }

    if (this.elem.hasAttribute('data-editor-tooltip')) {
      this.calculatePosition();
    }

    this.elem.classList.add('active');
    this.target.setAttribute('aria-expanded', "true");

    document.addEventListener('keydown', (e) => {
      e.key === "Escape" && this.close();
    });
  }

  close() {
    this.target.classList.remove(...Object.values(this.positionClasses));
    this.elem.classList.remove('active');
    this.target.setAttribute('aria-expanded', "false");
  }
}

const tooltipElems = document.querySelectorAll('.tooltip');
for (let tooltipElem of tooltipElems) {
  tooltipElem.tooltip = new Tooltip(tooltipElem)
}
